(() => {
  const roots = document.querySelectorAll('[data-a7-filter-root]');

  roots.forEach((root) => {
    const handle = String(root.dataset.a7CollectionHandle || '').toLowerCase();

    // Europe uses /collections/mens-tops and /collections/womens-tops for the
    // dedicated Bar Grip routes. Normalise those handles before the existing
    // A7 filter engine initialises so they resolve to the same dedicated
    // Men's Bar Grip / Women's Bar Grip groups used by the UK storefront.
    if (handle === 'mens-tops') {
      root.dataset.a7CollectionHandle = 'mens-bar-grip';
    } else if (handle === 'womens-tops') {
      root.dataset.a7CollectionHandle = 'womens-bar-grip';
    }
  });

  const currentSrc = document.currentScript && document.currentScript.src;
  if (!currentSrc) return;

  const baseSrc = new URL(currentSrc);
  baseSrc.pathname = baseSrc.pathname.replace(/a7-collection-filter\.js$/, 'a7-collection-filter-base.js');
  baseSrc.search = '';

  const script = document.createElement('script');
  script.src = baseSrc.toString();
  script.async = false;
  document.head.appendChild(script);
})();
